(ns frontend.view.settings2.surveys.timeseries.sub
  (:require [common.util :as cu]
            [frontend.view.settings2.surveys.sub :as surveys-sub]
            [frontend.view.settings2.surveys.timeseries.model :as model]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::selected-tab
 :<-
 [::state]
 (fn [state [_ ctx-path]]
   (if-let [selected-tab-str (get-in state
                                     (model/selected-tab-ctx-path ctx-path))]
     (->> model/tabs
          (cu/filter-by :tab-str-key selected-tab-str)
          (first))
     (->> model/tabs
          (first)))))

(rf/reg-sub
 ::row-to-highlight
 :<-
 [::state]
 (fn [state [_ ctx-path]]
   (get-in state (model/highlight-row-index-path-ctx-path ctx-path))))

(rf/reg-sub
 ::selected-questions
 :<-
 [::state]
 (fn [state [_ ctx-path]]
   (get-in state (model/selected-questions-ctx-path ctx-path) [])))

(rf/reg-sub
 ::preview-period
 :<-
 [::state]
 :<-
 [::surveys-sub/reference-period]
 (fn [[state template-period-type] [_ ctx-path]]
   ;; nil until ::init-preview has stored the day the preview was opened
   (when-let [today-ms (get-in state (model/preview-today-ctx-path ctx-path))]
     (model/preview-period {:period-type          (get-in state (model/preview-period-type-ctx-path ctx-path))
                            :period-value         (get-in state (model/preview-period-value-ctx-path ctx-path))
                            :template-period-type template-period-type
                            :today-ms             today-ms}))))

(rf/reg-sub
 ::preview-table
 (fn [[_ ctx-path _block]]
   (rf/subscribe [::preview-period ctx-path]))
 (fn [{:keys [selected]} [_ _ctx-path block]]
   (when selected
     (model/preview-table block (select-keys selected [:start-ts :end-ts])))))
